import { z } from 'zod';

import { AlertStatusSchema } from '@/entities/alert-status';

import { AssetTypeSchema } from './asset-type';

export const AssetMetadataSchema = z.object({
  capacity: z.number().optional(),
  cellType: z.string().optional(),
  manufacturer: z.string().optional(),
  cellChemistry: z.string().optional(),
  deviceType: z.string().optional(),
});

export const AssetSchema = z.object({
  id: z.string(),
  type: AssetTypeSchema,
  frontendId: z.string(),
  fullFrontendId: z.string(),
  accureSoc: z.number().optional(),
  bmsSoc: z.number().optional(),
  imbalanceSoc: z.number().optional(),
  temperature: z.number().optional(),
  throughput: z.number().optional(),
  alertStatus: AlertStatusSchema.nullable(),
  nbOpenTasks: z.number().optional(),
  metadata: AssetMetadataSchema,
});

export type Asset = z.infer<typeof AssetSchema>;
export type AssetMetadata = z.infer<typeof AssetMetadataSchema>;

export function assetSocOffset(asset: Asset): number | undefined {
  if (!asset.accureSoc || !asset.bmsSoc) {
    return undefined;
  }

  return Math.abs(asset.bmsSoc - asset.accureSoc);
}
